import { BaseConfig } from '../ServiceConfig';

export interface IdAdminConfiguration extends BaseConfig {
  '@type': 'type.googleapis.com/terra.v1.IdAdminServiceConfigData';
  url: string;
}

export const IdAdminConfigurationFields: (keyof IdAdminConfiguration)[] = [
  'url',
];

export const BlankIdAdminConfiguration: IdAdminConfiguration = {
  '@type': 'type.googleapis.com/terra.v1.IdAdminServiceConfigData',
} as IdAdminConfiguration;
